import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: 'add-dialog',
  templateUrl: './add-dialog.component.html',
  styleUrls: ['./add-dialog.component.less']
})
export class AddDialogComponent implements OnInit {

  isLoading: boolean = false;
  items: any = {};

  paring: any = {
    name: 'Select all',
    completed: true,
    color: 'primary',
    subtasks: [
      // {name: 'Primary', completed: false, color: 'primary'},
      // {name: 'Accent', completed: false, color: 'accent'},
      // {name: 'Warn', completed: false, color: 'warn'},
    ],
  };

  allowdZones: string[] = []
  allowdStates: any = []
  cycleStates: string[] = [ 'Mothers', 'Rooting', 'Vegetative', 'Flowering', 'Drying', 'Curing', 'Packing', 'Safe', 'End'];
  customState: string;
  zoneRole: string[] =  ['Mothers', 'Clones', 'Grow', 'Dry', 'Cure', 'Pack', 'Safe', 'General']

  selectAll: boolean = true;

  constructor(public dialogRef: MatDialogRef<AddDialogComponent>,
    private _api: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    if(this.data.type === 'cycle'){
      this.allowdStates = this.cycleStates
    }
    this.fetchData(this.data.type)
  }

  onConfirm() {
    if (this.data.name?.length === 0) {
      return;
    }
    this.isLoading = true;

    let finalData: any
    if(this.data.type === 'company'){
      finalData = {
        name: this.data.name,
        contactName: this.data.contactName,
        address: this.data.address,
        email: this.data.email,
        phone: this.data.phone,
      }
    }
    if(this.data.type === 'gateway'){
      finalData = {
        name: this.data.name,
        company: this.data.company,
        hardwareId: this.data.hardwareId
      }
    }
    if(this.data.type === 'zone'){
      finalData = {
        name: this.data.name,
        gateway: this.data.gateway,
        role: this.data.zoneRole,
        size: this.data.zoneSize
      }
    }
    if(this.data.type === 'sensor'){
      finalData = {
        name: this.data.name,
        hardwareId: this.data.hardwareId,
        kind: this.data.kind,
        zone: this.data.zoneId
      }
    }
    if(this.data.type === 'user'){
      let notificationsPlatforms = this.data.notificationsEnabled ? {
        email: this.data.notificationsEnabledEmail ? true : false,
        sms: this.data.notificationsEnabledSms ? true : false,
        push: this.data.notificationsEnabledPush?  true : false
      } 
      : {
        email: false,
        sms: false,
        push: false
      }
      finalData = {
        name: this.data.name,
        email: this.data.email,
        password: this.data.password,
        phone: this.data.phone,
        company: this.data.company,
        role: this.data.role,
        notificationsEnabled: this.data.notificationsEnabled,
        notificationsPlatforms: notificationsPlatforms
      }
    }
    if(this.data.type === 'cycle' && !this.data.zone){
      let sensors = [];
      if(this.paring.subtasks.length){
        this.paring.subtasks.forEach(sensor=>{
          if(sensor.completed){
            sensors.push(sensor.id)
          }
        })
      }
      finalData = {
        name: this.data.name,
        kind: this.data.kind,
        zone: this.data.zoneId,
        currentState: this.data.currentState,
        plantsQuantity: this.data.plantsQuantity,
        cycleTimes: this.data.cycleTimes,
        isAllSensors: this.selectAll,
        sensors: sensors
      }
      if(this.data.wetWeight){
        finalData = {...finalData, harvest: {wetWeight : this.data.wetWeight}}
      }
    }

    if(this.data.type === 'cycle' && this.data.zone){
      let sensors = [];
      if(this.paring.subtasks.length){
        this.paring.subtasks.forEach(sensor=>{
          if(sensor.completed){
            sensors.push(sensor.id)
          }
        })
      }
      finalData = {
        name: this.data.name,
        kind: this.data.kind,
        zone: this.data.zone.id,
        currentState: this.data.currentState,
        plantsQuantity: this.data.plantsQuantity,      
        cycleTimes: this.data.cycleTimes,
        isAllSensors: this.selectAll,
        sensors: sensors
      }
      if(this.data.wetWeight){
        finalData = {...finalData, harvest: {wetWeight : this.data.wetWeight}}
      }
    }

    

  this.data.function(finalData).subscribe(
      result => {
        this.dialogRef.close(this.data);
      }, err => {
        alert(err.message);
        this.isLoading = false;
      }, complete => {
        this.isLoading = false;
      }
    )
  }

  fetchData(type) {
    // this.loading = true;
    // if(type === 'gateway'){
    //   this.companyData();
    // }
    if(type === 'zone'){
      this.gatewayData();
    }
    if(type === 'sensor'){
      this.sensorData();
      this.zoneData();
    }
    if(type === 'cycle' && !this.data.zone){
      this.zoneData();
    }
    if(type === 'cycle' && this.data.zone){
      this.items['zone'] = [this.data.zone]
      this.allowdZones = [this.data.zone]
      this.data.cycleTimes = this.data.zone ? this.data.zone.company.settings.cycleTimes : {}
      this.getParing(this.data.zone.id)
    }
    
    
  }

  gatewayData() {
    let company
    if (localStorage.getItem('currentCompany')) {
      company = JSON.parse(localStorage.getItem('currentCompany'));
     
    }
    this._api.get<any>(`/gateway/company/${company._id}`).subscribe(resp => {
        this.items['gateway'] = resp.gateways;
        
    }, err => {
        alert(err.message);
    });

  }

  sensorData(){
    this._api.get<any>('/sensor').subscribe(resp => {
      this.items['sensor'] = resp.sensors.map(s => ({
          ...s,
          average: (s.average || []).join(',')
      }));
      this.items['sensorKinds'] = resp.sensorKinds;
       let actionTypes = resp.actionTypes;
  }, err => {
      alert(err.message);
  });
  }

  zoneData(){
    let company
    if (localStorage.getItem('currentCompany')) {
      company = JSON.parse(localStorage.getItem('currentCompany'));
     
    }
    this._api.get<any>(`/zone/company/${company._id}?slim=true`).subscribe(resp => {
      this.items['zone'] = resp;
      this.allowdZones = resp
      this.data.cycleTimes = resp.length ? resp[0].company.settings.cycleTimes : {}
      if(this.data.type === 'cycle'){
        this.setCurrentState();
      }
    }, err => {
        alert(err.message);
    });
  }

  getParing(zoneId){
    this.fillterAlowd('state')
    this.paring.subtasks = []
    this._api.get<any>(`/sensor/sensors/${zoneId}`).subscribe(resp => {
      resp.sensors.forEach(sensor => {
        this.paring.subtasks.push({name: sensor.name, id:sensor.id,  completed: true, color: 'primary', kind: sensor.kind})
      })
      this.setAll(true)
  }, err => {
      alert(err.message);
  });
  }

  updateAllComplete() {
    this.selectAll = this.paring.subtasks != null && this.paring.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.paring.subtasks == null) {
      return false;
    }
    return this.paring.subtasks.filter(t => t.completed).length > 0 && !this.selectAll;
  }

  setAll(completed: boolean) {
    this.selectAll = completed;
    if (this.paring.subtasks == null) {
      return;
    }
    this.paring.subtasks.forEach(t => (t.completed = completed));
  }

  fillterAlowd(type: string){
    if(type === 'state'){
      let selectedZoneRole = this.items['zone'].find(zone => zone.id === this.data.zoneId || zone.id === this.data.zone.id)
      this.allowdStates = this.cycleStates.filter(state => {
        if(selectedZoneRole.role === 'Mothers'){
          return state === 'Mothers' 
        }
        if(selectedZoneRole.role === 'Clones'){
          return state === 'Rooting' || state === 'Vegetative'
        }
        if(selectedZoneRole.role === 'Grow'){
          return state === 'Vegetative' || state === 'Flowering'
        }
        if(selectedZoneRole.role === 'Dry'){ 
          return state === 'Drying' 
        }
        if(selectedZoneRole.role === 'Cure'){ 
          return state === 'Curing' 
        }
        if(selectedZoneRole.role === 'Pack'){ 
          return state === 'Packing' 
        }
        if(selectedZoneRole.role === 'Safe'){ 
          return state === 'Safe' 
        }
        if(selectedZoneRole.role === 'General'){ 
          return state === 'Rooting' || state === 'Vegetative' ||  state === 'Flowering' 
          || state === 'Drying' ||  state === 'Curing' || state === 'Packing' || state === 'Safe'
        }
      })
    }
    if(type === 'zone'){
      this.allowdZones = this.items['zone'].filter(zone => {
        if(this.data.currentState === 'Mothers'){
          return (zone.role === 'Mothers') 
        }
        if(this.data.currentState === 'Rooting'){
          return (zone.role === 'Clones' || zone.role === 'General')
        }
        if(this.data.currentState === 'Vegetative'){
          return (zone.role === 'Clones' || zone.role === 'Grow' || zone.role === 'General')
        }
        if(this.data.currentState === 'Flowering'){
          return (zone.role === 'Grow' || zone.role === 'General')
        }
        if(this.data.currentState === 'Drying'){
          return (zone.role === 'Dry'  || zone.role === 'General')
        }
        if(this.data.currentState === 'Curing'){
          return (zone.role === 'Cure' || zone.role === 'General')
        }
        if(this.data.currentState === 'Packing'){
          return (zone.role === 'Pack' || zone.role === 'General')
        }
        if(this.data.currentState === 'Safe'){
          return (zone.role === 'Safe' || zone.role === 'General')
        }
      })
    }
  }

  setCurrentState(){
    let hasGeneral = this.items['zone'].find(zoneRole => zoneRole.role === 'General')
    if(!hasGeneral){
      let states = new Set
      this.items['zone'].forEach( zone => {
        if(zone.role === 'Mothers'){
          states.add('Mothers')
        }
        if(zone.role === 'Clones'){
          states.add('Rooting')
          states.add('Vegetative')
        }
        if(zone.role === 'Grow'){
          states.add('Vegetative')
          states.add('Flowering')
        }
        if(zone.role === 'Dry'){ 
          states.add('Drying')
        }
        if(zone.role === 'Cure'){ 
          states.add('Curing')
        }
        if(zone.role === 'Pack'){ 
          states.add('Packing')
        }
        if(zone.role === 'Safe'){ 
          states.add('Safe')
        }
      })
      let statesArray = Array.from(states)
      this.allowdStates = this.cycleStates.filter( state => state === statesArray.find(allwoedState => allwoedState === state))
    }else{
      this.allowdStates = this.allowdStates
    }
  }

}
